/*  ========================================================================
    # Scripts - Language Switcher
    ========================================================================  */

/**
 * Script that opens and closes the language switcher.
 */

const LanguageSwitcher = {
  cfg: {
    buttonElements: document.querySelectorAll('.c-language-switcher'),
    states: {
      open: 'c-language-switcher--open'
    }
  },

  /**
   * Handle button click.
   */
  handleButtonclick() {
    this.cfg.buttonElements.forEach(button => {
      button.addEventListener('click', () => {
        button.classList.toggle(this.cfg.states.open);
      });
    });

    document.addEventListener('click', e => {
      this.cfg.buttonElements.forEach(button => {
        if (!button.contains(e.target)) {
          button.classList.remove(this.cfg.states.open);
        }
      });
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.buttonElements) {
      this.handleButtonclick();
    }
  }
};

export default LanguageSwitcher;
